(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dtHeader", [], factory);
	else if(typeof exports === 'object')
		exports["dtHeader"] = factory();
	else
		root["dtHeader"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition